// src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import vertaalbestanden
import enTranslation from './locales/en.json';
import nlTranslation from './locales/nl.json';
import deTranslation from './locales/de.json';
import frTranslation from './locales/fr.json';
import esTranslation from './locales/es.json';
import svTranslation from './locales/sv.json';

const resources = {
  en: {
    translation: enTranslation
  },
  nl: {
    translation: nlTranslation
  },
  de: {
    translation: deTranslation
  },
  fr: {
    translation: frTranslation
  },
  es: {
    translation: esTranslation
  },
  sv: {
    translation: svTranslation
  }
};

i18n
  // Detecteer de taal van de gebruiker
  .use(LanguageDetector)
  // Verbind i18next met React
  .use(initReactI18next)
  // Initialiseer i18next
  .init({
    resources,
    fallbackLng: 'nl', // Standaardtaal
    debug: import.meta.env.DEV, // Debug mode in development
    
    // Detectie opties
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React escapet al
    },

    // Namespace configuratie
    defaultNS: 'translation',
    ns: ['translation'],
  });

export default i18n;